'use client';

import { LEGAL_ADMIN_PAGE } from '@/features/admin/constants/legal-admin-ui-copy';
import { LegalDocumentAdminPage } from '@/features/admin/presentation/sections/LegalDocumentAdminPage';

export interface TermosDeUsoAdminPageProps {
  editorDisplayName: string;
}

export default function TermosDeUsoAdminPage({ editorDisplayName }: TermosDeUsoAdminPageProps) {
  return (
    <LegalDocumentAdminPage
      kind="terms"
      title={LEGAL_ADMIN_PAGE.TERMS_TITLE}
      subtitle={LEGAL_ADMIN_PAGE.TERMS_SUBTITLE}
      editorDisplayName={editorDisplayName}
    />
  );
}
